import { useLocalObservable } from 'mobx-react-lite';
import { useEffect } from 'react';

import { IUseMyContactsPresenterProps, IMyContactsPresenter } from '../SelectContacts.types';

export const useMyContactsPresenter = ({
  contacts,
  hasMore,
  loadMore,
  isLoading,
}: IUseMyContactsPresenterProps): IMyContactsPresenter => {
  const presenter = useLocalObservable<IMyContactsPresenter>(() => ({
    contacts,
    isLoading,
    hasMore,
    loadMore,

    get contactsIds(): string[] {
      return presenter.contacts.map((contact) => contact.id);
    },
  }));

  useEffect(() => {
    presenter.contacts = contacts;
    presenter.isLoading = isLoading;
    presenter.hasMore = hasMore;
    presenter.loadMore = loadMore;
  }, [contacts, isLoading, hasMore, loadMore]);

  return presenter;
};
